import React from "react";
import { Typography, Box, Divider } from "@mui/material";
import { MetricCardData } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles } from "../../styles";

interface TimeBasedCardProps {
  data: MetricCardData;
}

export const TimeBasedCard: React.FC<TimeBasedCardProps> = ({ data }) => {
  return (
    <BaseCard data={data}>
      <Box
        sx={{
          ...operationsDashboardStyles.flexCenter,
          ...operationsDashboardStyles.marginBottom24,
        }}
      >
        <Typography sx={operationsDashboardStyles.unitText}>
          {data.unit ?? ""}
        </Typography>
        <Typography sx={operationsDashboardStyles.valueText}>
          {data.value}
        </Typography>
      </Box>
      <Divider sx={operationsDashboardStyles.divider} />
      <Box sx={operationsDashboardStyles.textCenter}>
        <Box>
          <Typography sx={operationsDashboardStyles.comparisonValue}>
            {data.timeframe}
          </Typography>
          <Typography sx={operationsDashboardStyles.comparisonLabel}>
            {data.subTimeframe}
          </Typography>
        </Box>
      </Box>
    </BaseCard>
  );
};
